import { makeRequest } from 'utils/requestLogger';

export default (participationID, publishBoolean) =>
  makeRequest(
    'put',
    `/api/participations/${participationID}/publish_student_notes`,
    { publish: publishBoolean }
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/publishStudentNotes.js